import React, { HTMLAttributes, useMemo, useState, useCallback, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
// const { getUrl, Big } = Util;
import store from "store";

import { Checkbox } from "antd";
import AppDivToLogin from "components/app/div/toLogin";
import XtTabs from "components/xt/tabs";

import CMPT_openOrder from "./openOrder";
import CMPT_orderHistory from "./orderHistory";
import CMPT_tradeHistory from "./tradeHistory";
import CMPT_funds_spot from "./funds/spot";
import CMPT_funds_lever from "./funds/lever";
import CMPT_position from "./position";
// import CMPT_subscription from "./subscription";
// import CMPT_redemption from "./redemption";

import styles from "./index.module.scss";

enum HistoryTypeEnum {
  openOrder = "openOrder", //当前委托
  orderHistory = "orderHistory", //历史委托
  tradeHistory = "tradeHistory", //成交记录
  funds = "funds", //资产管理
  position = "position", //持仓列表，杠杆
  subscription = "subscription", //申购记录，etf
  redemption = "redemption", //赎回记录，etf
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  const { isH5 } = store.app;
  const { isLogin } = store.user;
  const { name, type, isLever, isEtf } = store.market;
  const { openOrder } = store.balances;

  const [openOrderCount, setOpenOrderCount] = useState<undefined | number>();
  const [historyType, setHistoryType] = useState(HistoryTypeEnum.openOrder);
  const navItems = useMemo(() => {
    const ary = [
      {
        key: HistoryTypeEnum.openOrder,
        label: t("trade.openOrders") + (openOrderCount !== undefined ? `(${openOrderCount})` : ""),
      },
      {
        key: HistoryTypeEnum.orderHistory,
        label: t("trade.orderHistory"),
      },
      {
        key: HistoryTypeEnum.tradeHistory,
        label: t("trade.tradeHistory"),
      },
      {
        key: HistoryTypeEnum.funds,
        label: t("trade.funds"),
      },
    ];

    // if (isLever) {
    //   ary.push({
    //     key: HistoryTypeEnum.position,
    //     label: t("trade.positionList"),
    //   });
    // }

    if (isEtf) {
      ary.push({
        key: HistoryTypeEnum.subscription,
        label: t("trade.subscription"),
      });
      ary.push({
        key: HistoryTypeEnum.redemption,
        label: t("trade.redemption"),
      });
    }

    return ary;
  }, [isLever, isEtf, openOrderCount]);

  const isCheckboxVisible = useMemo(() => {
    return [HistoryTypeEnum.openOrder, HistoryTypeEnum.orderHistory, HistoryTypeEnum.tradeHistory].includes(historyType);
  }, [historyType]);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const handleCheckboxChange = useCallback((e) => {
    setIsCheckboxChecked(e.target.checked);
  }, []);

  const resetEffect = useMemo(() => {
    return [name, type].join("@");
  }, [name, type]);

  const [openOrderClickStamp, setOpenOrderClickStamp] = useState<string>();
  const handleTabClick = useCallback((val) => {
    if (val === HistoryTypeEnum.openOrder) {
      setOpenOrderClickStamp(Math.round(Date.now() / 100) + "");
      // store.balances.getOpenOrder();
    }
  }, []);

  useEffect(() => {
    if (!isLever && historyType === HistoryTypeEnum.position) {
      setHistoryType(HistoryTypeEnum.openOrder);
      return;
    }
    if (!isEtf && [HistoryTypeEnum.subscription, HistoryTypeEnum.redemption].includes(historyType)) {
      setHistoryType(HistoryTypeEnum.openOrder);
      return;
    }
  }, [isLever, isEtf]);

  useEffect(() => {
    // console.log("hooooooo---");
    if (historyType === HistoryTypeEnum.openOrder) return;
    if (!openOrder) return setOpenOrderCount(undefined);
    const items = openOrder.filter((doc) => {
      if (isCheckboxChecked && doc.symbol !== name) return false;
      return true;
    });
    setOpenOrderCount(items.length);
  }, [name, openOrder, historyType, isCheckboxChecked]);

  return (
    <div className={cx(styles.main, className)}>
      <XtTabs
        className={styles.nav}
        activeKey={historyType}
        items={navItems}
        onClick={handleTabClick}
        onChange={(val) => setHistoryType(val as HistoryTypeEnum)}
        isArrow={true}
        resetEffect={resetEffect}
      >
        {isCheckboxVisible && !isH5 && (
          <Checkbox className={styles.checkbox} checked={isCheckboxChecked} onChange={handleCheckboxChange}>
            {t("trade.hideOtherSymbol")}
          </Checkbox>
        )}
      </XtTabs>

      {!isLogin ? (
        <AppDivToLogin className={styles.noLogin} />
      ) : (
        <div className={styles.content}>
          {historyType === HistoryTypeEnum.openOrder && (
            <CMPT_openOrder
              isHideOtherPairs={isCheckboxChecked}
              setHideOtherPairs={setIsCheckboxChecked}
              setOpenOrderCount={setOpenOrderCount}
              clsUl={styles.ul}
              clsLi={styles.li}
              clickStamp={openOrderClickStamp}
            />
          )}
          {historyType === HistoryTypeEnum.orderHistory && (
            <CMPT_orderHistory isHideOtherPairs={isCheckboxChecked} setHideOtherPairs={setIsCheckboxChecked} clsUl={styles.ul} clsLi={styles.li} />
          )}
          {historyType === HistoryTypeEnum.tradeHistory && (
            <CMPT_tradeHistory isHideOtherPairs={isCheckboxChecked} setHideOtherPairs={setIsCheckboxChecked} clsUl={styles.ul} clsLi={styles.li} />
          )}
          {historyType === HistoryTypeEnum.funds &&
            (!isLever ? <CMPT_funds_spot clsUl={styles.ul} clsLi={styles.li} /> : <CMPT_funds_lever clsUl={styles.ul} clsLi={styles.li} />)}
          {historyType === HistoryTypeEnum.position && <CMPT_position />}
          {/*{historyType === HistoryTypeEnum.subscription && <CMPT_subscription clsUl={styles.ul} clsLi={styles.li} />}*/}
          {/*{historyType === HistoryTypeEnum.redemption && <CMPT_redemption clsUl={styles.ul} clsLi={styles.li} />}*/}
        </div>
      )}
    </div>
  );
};

export default observer(Main);
// export default Main;
